module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_esri_white.68d804dd.png";